import script from "./CategoryNew.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryNew.vue?vue&type=script&setup=true&lang=js"

import "./CategoryNew.vue?vue&type=style&index=0&id=6a6250d6&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6250d6"]])

export default __exports__